import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/image-to-image/page.tsx");
